import { translate } from "@/i18n";
import { cursorsMessages } from "@/i18n/messages/cursors";

const THINKING_PHRASE_KEYS = [
  "thinkingPondering",
  "thinkingPontificating",
  "thinkingHarmonizing",
  "thinkingConjuring",
  "thinkingMarinating",
  "thinkingPercolating",
  "thinkingSimmering",
  "thinkingNoodling",
  "thinkingRuminating",
  "thinkingDistilling",
  "thinkingCrystallizing",
  "thinkingUntangling",
] as const satisfies ReadonlyArray<keyof typeof cursorsMessages.en>;

/** A playful thinking word, stable per seed, in the current app language. */
export function getThinkingPhrase(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return translate(
    cursorsMessages,
    THINKING_PHRASE_KEYS[hash % THINKING_PHRASE_KEYS.length]!,
  );
}
